
<template>

  <svg viewBox="0 0 47.625 47.625">

    <g transform="translate(-97.5361 -127.58)">

      <g transform="matrix(.968956 0 0 .968956 3.68936 4.62205)">

        <circle cx="121.429" cy="151.473" r="22.3053" fill="none" stroke="currentColor" stroke-width="3.175" />

        <path d="m112.759 138.773c-1.42615 0-2.57452 1.12375-2.57452 2.51974v17.4248c0 3.31547 1.40432 5.45548 4.79144 5.45548h15.3882c1.42616 0 2.30994-0.85919 2.30994-2.25516v-18.9115h-2.91043v17.7271h-17.7271c0-2.19869 1.77006-3.175 3.96875-3.175h12.7v-18.7854zm1.65882 5.02708h9.26042v1.05833h-9.26042z"
        
          fill="currentColor" stroke-width="3.76813" />

      </g>

    </g>

  </svg>

</template>
